<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			return {

			}
		}
	};
</script>

<!-- 改用less -->
<style lang="less">
	// 这是less的全局变量，需要添加变量到src/public/variable.less里添加
	@import url('./public/variable.less');

	/* banner-top */
	* {
		margin: 0;
		padding: 0;
		// 全局字体设置
		font-family: 'Arial', 'Microsoft YaHei', '黑体', '宋体', sans-serif;
	}

	//rem适配
	body {
		font-size: 12px;
	}

	.scope-normal {
		color: @vue-text-color;
	}

	.scope-blue {
		color: @vue-text-color-active;
		text-decoration: underline;
		cursor: pointer;
	}

	.scope-grey {
		color: @vue-text-color-grey;
	}

	.scope-green {
		color: #53c41a;
	}

	.scope-red {
		color: #bd0101;
	}

	.scope-step {
		display: flex;
		align-items: center;

		img {
			width: 14px;
			height: 14px;
			margin-right: @vue-spacing-row-sm;
		}

		.scope-point {
			width: 14px;
			height: 14px;
			border-radius: @vue-border-radius-circle;
			margin-right: @vue-spacing-row-sm;
		}

		.scope-point-blue {
			background: @vue-bg-color-active;
		}

		.scope-point-green {
			background: @vue-bg-color-green;
		}

		.scope-point-red {
			background: @vue-bg-color-red;
		}
	}

	.scope-button {
		display: flex;

		.scope-button-item {
			cursor: pointer;
			margin-right: @vue-spacing-row-base;
		}

		.scope-button-grey {
			color: @vue-text-color-grey;
		}

		.scope-button-blue {
			color: @vue-text-color-active;
		}

		.scope-button-green {
			color: @vue-text-color-green;
		}

		.scope-button-red {
			color: @vue-text-color-red;
		}
	}

	.scope-image-breviary {
		width: 380px;
		display: block;

		img {
			height: 80px;
		}
	}

	.custom-scroll-bar::-webkit-scrollbar {
		width: 8px;
		height: 1px;
	}

	.custom-scroll-bar::-webkit-scrollbar-thumb {
		border-radius: 8px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #e3e3e3;
	}

	.custom-scroll-bar::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 8px;
		background: #f3f3f3;
	}

	.table-score {
		height: 100%;
		display: flex;
		align-items: center;

		img {
			width: 16px;
			height: 16px;
			margin-right: 2px;
		}

		span {
			font-size: @vue-font-size-min;
			color: orange;
			padding: 0px 5px;
			border: 1px solid orange;
			box-sizing: border-box;
			border-radius: @vue-border-radius-base;
			line-height: 20px;
		}
	}
</style>
